import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';

import { store } from './store';
import App from './App';

import './css/style.scss';
import './css/plugins.scss';

dayjs.locale('ru');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
);
